export default __webpack_public_path__ + "static/media/02.5208baa9.png";